import { TMetaPrimitives } from '@cian/logger/shared';
import { prepareProjects } from 'shared/mappers/prepareProjects';
import {
  fetchGetProjects,
  IGetProjectsRequest,
  TGetProjectsResponse,
} from 'shared/repositories/promotions-flow-control/v1/get-projects';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TProjectsList } from 'shared/types/project';

export type { IGetProjectsRequest };

export async function loadProjects(
  { logger, httpApi }: IApplicationContext,
  parameters: IGetProjectsRequest,
): Promise<TProjectsList> {
  try {
    const result: TGetProjectsResponse = await fetchGetProjects({ httpApi, parameters });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/loadProjects.ts [loadProjects]',
        message: 'Не удалось получить список проектов',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return { projects: [], total: 0 };
    }

    return prepareProjects(result.response);
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/loadProjects.ts [loadProjects]',
      message: 'Не удалось получить список проектов',
    });

    throw error;
  }
}
